import React from 'react';
import { Rating } from 'semantic-ui-react';

export default function Stars({ starRating }) {
  if (!starRating) return <span>[Not yet rated]</span>;
  const ratingPercentage = 100 - (starRating / 5) * 100;

  return (
    <div style={{ position: 'relative', display: 'inline' }}>
      <div style={{ position: 'absolute', left: 0, top: 0 }}>
        <Rating icon='star' maxRating={5} defaultRating={0} disabled />
      </div>
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
        }}
      >
        <div
          style={{
            position: 'relative',
            overflow: 'hidden',
            left: `-${ratingPercentage}%`,
          }}
        >
          <Rating
            icon='star'
            maxRating={5}
            defaultRating={5}
            style={{
              position: 'relative',
              left: `${ratingPercentage}%`,
            }}
            color='orange'
            disabled
          />
        </div>
      </div>
    </div>
  );
}
